module.exports = __webpack_public_path__ + "img/AboutExport1.4a9218ef.png";